//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $$ from 'jquery'
import {requestByPost} from '@/util/request'
import {API} from '@/util/api'
import { Toast, PullRefresh,Empty,Overlay} from 'vant';
import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'
export default {
 name: 'home',
 data(){
    return {
      value: null,
      navShowCCC:1
    }
  },
 components:{
    Header,
    Footer
 },

  methods:{
    navSh(num){
      this.navShowCCC = num
      console.log(this.navShowCCC)
    }
    
  },
  mounted(){
    document.title = "关于平台"
    $$(".p0a").click(function(){
      $$(".p0a").addClass("active")
      $$(".p1a").removeClass("active")
      $$(".oneShow").show()
      $$(".twoShow").hide()
      $$(".listOnefirst").eq(0).hide()
      $$(".listOnefirst").eq(1).show()
    })
    $$(".p1a").click(function(){
      $$(".p1a").addClass("active")
      $$(".p0a").removeClass("active")
      $$(".twoShow").show()
      $$(".oneShow").hide()
      $$(".listOnefirst").eq(0).show()
      $$(".listOnefirst").eq(1).hide()
    })
    $$(".p1ab").click(function(){
      $$(".p0a").addClass("active")
      $$(".p1a").removeClass("active")
      $$(".oneShow").show()
      $$(".twoShow").hide()
      $$(".listOnefirst").eq(0).hide()
      $$(".listOnefirst").eq(1).show()
    })
    $$(".p2ab").click(function(){
            $$(".p1a").addClass("active")
      $$(".p0a").removeClass("active")
      $$(".twoShow").show()
      $$(".oneShow").hide()
      $$(".listOnefirst").eq(0).show()
      $$(".listOnefirst").eq(1).hide()
    })
    $$(".oneShow").hover(function(){
          $$(".img09").css("opacity",1)
    },function(){
         $$(".img09").css("opacity",0)
    })
    $$(".twoShow").hover(function(){
          $$(".img90").css("opacity",1)
    },function(){
          $$(".img90").css("opacity",0)
    })

    $$(document).scroll(function(){
      var y = $$(document).scrollTop()
      console.log()
      if(y >= 100){
          $(".newindextop").addClass("newindextop1").css({"top":0})
          $(".navChidBor").addClass("newindextop1").css({"top":77})

      }else{
         $(".newindextop").removeClass("newindextop1").css({"top":0})
         $(".navChidBor").removeClass("newindextop1").css({"top":0})
      }
    })
  },
  created(){
    this.$store.commit('home/setMenuActive', 4);
   
    that.fnInitDataOne();
    
    
  },
  updated(){
    //每个16:9的图片加载完重新算高度
    $$(".autoHeight").each(function(){
      let widthNum = $$(this).width();
      $$(this).height(widthNum*9/16);
    });
    //每个16:7.52的图片(企业封面)加载完重新算高度
    $$(".autoCompanyImgHeight").each(function(){
      let widthNum = $$(this).width();
      $$(this).height(widthNum*7.52/16);
    });
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/about.vue